import styled from 'styled-components';
import { hexToRgba } from '../../../../utils/style';

import { NewStyleColor } from '../../../../utils/styles-constants';

const PageTitle = styled('div')`
	padding: 10px 0 5px 10px;
	font-size: 13px;
	line-height: 20px;
	color: ${hexToRgba(NewStyleColor.White, 75)};
`;

const PageInput = styled('input')`
	width: 50px!important;
	padding: 10px!important;
`;

export {
	PageTitle,
	PageInput,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/LinkPanel/styles.ts